/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useState } from 'react';
import {
  Box,
  Checkbox,
  Fab,
  FormControlLabel,
  Grid,
  TextField,
} from '@material-ui/core';
import { useForm } from 'react-hook-form';
import SaveOutlinedIcon from '@material-ui/icons/SaveOutlined';
import { itemClasses } from '../themes/classes';
import { PopupDialog } from '../Shared';
import AutoFieldLocal from '../components/fields/AutoFieldLocal';
import useTasks from '../hooks/useTasks';
import { useEmployees, useTemplate } from '../hooks';

export const indexTheList = (list: any) => {
  return list.map((item: any, index: any) => {
    return {
      ...item,
      index,
    };
  });
};

const PopupVacation = ({
  open,
  onClose,
  row,
  editAction,
  isRTL,
  words,
  user,
}: any) => {
  const classes = itemClasses();
  const [desc, setDesc] = useState('');

  const [emplvalue, setEmplvalue] = useState<any>(null);
  const [taskvalue, setTaskvalue] = useState<any>(null);
  const [overtime, setOvertime] = useState(0);
  const [deduction, setDeduction] = useState(0);
  const [bonos, setBonos] = useState(0);
  const [isWorking, setIsWorking] = useState(true);
  const [isAbsent, setIsAbsent] = useState(false);

  const { tasks } = useTasks();

  const { tempwords } = useTemplate();
  const { employeesfull: employees } = useEmployees();

  const { register, handleSubmit, errors } = useForm();

  useEffect(() => {
    if (row && row.employeeId) {
      const empId = row?.employeeId;
      const contractId = row?.contractId;
      if (contractId) {
        const tsk = tasks.filter((ts: any) => ts._id === contractId)[0];
        setTaskvalue(tsk);
      }
      if (empId) {
        const empl = employees.filter((emp: any) => emp._id === empId)[0];
        setEmplvalue(empl);
      }
      setOvertime(row.overtime);
      setDeduction(row.deduction);
      setBonos(row.bonos);
      setIsWorking(row.isWorking);
      setIsAbsent(row.isAbsent);
      setDesc(row?.note);
    }
  }, [open]);

  const resetAll = () => {
    setEmplvalue(null);
    setTaskvalue(null);
    setOvertime(0);
    setDeduction(0);
    setBonos(0);
    setIsWorking(true);
    setIsAbsent(false);
    setDesc('');
  };

  const editLocalItem = () => {
    if (!row) {
      return;
    }
    const itemdata = {
      ...row,
      contractId: taskvalue?._id,
      contractName: taskvalue?.name,
      contractNameAr: taskvalue?.nameAr,
      overtime,
      deduction,
      bonos,
      isWorking,
      isAbsent,
      note: desc,
      userId: user._id,
    };
    editAction(itemdata);
    onFormClose();
  };
  const onFormClose = () => {
    onClose();
    resetAll();
  };

  return (
    <PopupDialog
      open={open}
      onClose={onFormClose}
      maxWidth={'lg'}
      classes={classes}
    >
      <Box
        display="flex"
        style={{
          flex: 1,
          margin: 20,
          direction: isRTL ? 'rtl' : 'ltr',
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <AutoFieldLocal
              name="employee"
              title={tempwords?.employee}
              words={words}
              options={employees.filter((emp: any) => !emp.disabled)}
              value={emplvalue}
              setSelectValue={setEmplvalue}
              isRTL={isRTL}
              fullWidth
              disabled
              mb={0}
            ></AutoFieldLocal>
          </Grid>
          <Grid item xs={4}>
            <AutoFieldLocal
              name="task"
              title={tempwords?.task}
              words={words}
              options={tasks}
              value={taskvalue}
              setSelectValue={setTaskvalue}
              isRTL={isRTL}
              fullWidth
              mb={0}
            ></AutoFieldLocal>
          </Grid>
          <Grid item xs={4}>
            <Box display={'flex'} p={1}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isWorking}
                    onChange={() => {
                      setIsWorking(!isWorking);
                      if (!isWorking) setIsAbsent(false);
                    }}
                    name="bold"
                    color="primary"
                  />
                }
                label={isRTL ? 'حاضر' : 'Present'}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isAbsent}
                    onChange={() => {
                      setIsAbsent(!isAbsent);
                      if (!isAbsent) setIsWorking(false);
                    }}
                    name="bold"
                    color="primary"
                  />
                }
                label={isRTL ? 'غائب' : 'Absent'}
              />
            </Box>
          </Grid>
          <Grid item xs={4}>
            <TextField
              name="overtime"
              onChange={(e: any) => setOvertime(Number(e.target.value))}
              value={overtime}
              label={isRTL ? 'اضافي' : 'Overtime'}
              error={errors.price ? true : false}
              variant="outlined"
              inputRef={register}
              type="number"
              fullWidth
              margin="dense"
              onFocus={(e) => e.target.select()}
              // inputProps={{
              //   style: { textAlign: 'right', fontSize: 13, height: 13 },
              //   inputMode: 'decimal',
              // }}
            />
          </Grid>

          <Grid item xs={4}>
            <TextField
              name="bonos"
              onChange={(e: any) => setBonos(Number(e.target.value))}
              value={bonos}
              label={isRTL ? 'مكافئة' : 'Bonos'}
              error={errors.price ? true : false}
              variant="outlined"
              inputRef={register}
              type="number"
              fullWidth
              margin="dense"
              onFocus={(e) => e.target.select()}
              // inputProps={{
              //   style: { textAlign: 'right', fontSize: 13, height: 13 },
              //   inputMode: 'decimal',
              // }}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              name="deduction"
              onChange={(e: any) => setDeduction(Number(e.target.value))}
              value={deduction}
              label={isRTL ? 'خصم' : 'Deduction'}
              error={errors.price ? true : false}
              variant="outlined"
              inputRef={register}
              type="number"
              fullWidth
              margin="dense"
              onFocus={(e) => e.target.select()}
              // inputProps={{
              //   style: { textAlign: 'right', fontSize: 13, height: 13 },
              //   inputMode: 'decimal',
              // }}
            />
          </Grid>
          <Grid item xs={1}>
            <Fab
              style={{ marginLeft: 10, marginRight: 10, marginTop: 5 }}
              color="primary"
              size="small"
              onClick={handleSubmit(editLocalItem)}
              title="Create new row"
            >
              <SaveOutlinedIcon />
            </Fab>
          </Grid>

          <Grid item xs={12}>
            <div>
              <TextField
                name="desc"
                onChange={(e: any) => setDesc(e.target.value)}
                value={desc}
                label={words?.description}
                variant="outlined"
                margin="dense"
                onFocus={(e) => e.target.select()}
                fullWidth
                multiline
                rowsMax={2}
                rows={2}
                style={{ marginTop: 0 }}
              />
            </div>
          </Grid>
        </Grid>
      </Box>
    </PopupDialog>
  );
};

export default PopupVacation;
